import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AggregatorProcessApi, AggregatorProcessListApi } from '../models';
import { AggregatorAdapter } from './aggregator.adapter';
import { AggrtConfigService, AggregatorCoreApiService } from '@selfai-platform/pipeline-shared';

@Injectable({
  providedIn: 'root',
})
export class AggregatorProcessApiService extends AggregatorCoreApiService implements AggregatorAdapter {
  constructor(
    private readonly http: HttpClient,
    aggrtConfigService: AggrtConfigService,
  ) {
    super(aggrtConfigService);
  }
  loadProcessWithRoutes(processUuid: string): Observable<AggregatorProcessApi> {
    const url = this.buildUrl(`/routes/getCurrent/${processUuid}`);

    return this.http.get<AggregatorProcessApi>(url);
  }

  saveRoutes(processWithRoutes: AggregatorProcessApi, singleUuid?: string): Observable<void> {
    let url = this.buildUrl('/routes/update');
    if (singleUuid) {
      url += `/single/${singleUuid}`;
    }

    return this.http.post<void>(url, processWithRoutes);
  }

  loadProcessList(): Observable<AggregatorProcessListApi> {
    const url = this.buildUrl('/routes/getProcessesList');

    return this.http.get<AggregatorProcessListApi>(url);
  }

  loadProcessListFull(): Observable<AggregatorProcessApi[]> {
    const url = this.buildUrl('/routes/getAll');

    return this.http.get<AggregatorProcessApi[]>(url);
  }
}
